import {Component, OnInit, Input} from '@angular/core'

@Component({
  selector: 'dmmp-desktop',
  templateUrl: './desktop.component.html'
})
export class DesktopComponent implements OnInit {

  @Input() startDate
  @Input() endDate
  @Input() localization
  @Input() items
  date = 'Fecha'
  hour = 'Hora'
  location = 'Lugar'

  constructor() {
    this.items = []
  }

  ngOnInit(): void {
  }

}
